import type { ActionLogEntry } from '@/types';

export interface ActionLogLabel {
  title: string;
  description?: string;
}

export const getActionLogLabel = (entry: ActionLogEntry): ActionLogLabel => {
  switch (entry.kind) {
    case 'customer.created':
      return { title: 'Client added' };
    case 'customer.updated':
      return { title: 'Client renamed' };
    case 'customer.archived':
      return { title: 'Client archived' };
    case 'visit.marked':
      return { title: 'Visit marked', description: entry.membershipName };
    case 'membership.created':
      return { title: 'Pass added', description: entry.membershipName };
    case 'membership.updated':
      return { title: 'Pass updated', description: entry.membershipName };
    case 'membership.archived':
      return { title: 'Pass archived', description: entry.membershipName };
    default: {
      const exhaustive: never = entry;
      return exhaustive;
    }
  }
};

export const isDestructiveKind = (kind: ActionLogEntry['kind']): boolean =>
  kind === 'customer.archived' || kind === 'membership.archived';
